var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-button-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "automation-trigger-button",
          on: { click: _vm.toggleAutomationList },
        },
        [
          _c("AutomationIcon", { staticClass: "automation-icon" }),
          _vm._v(" "),
          _vm.showText
            ? _c("span", { staticClass: "button-text" }, [
                _vm._v(_vm._s(_vm.$t("message.automations"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.visible
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dropdown-content",
                  class: { "inline-mode": _vm.subMenuMode === "inline" },
                },
                [
                  _vm.subMenuMode === "overlay"
                    ? [
                        _vm._l(
                          _vm.categoriesWithAutomations,
                          function (category) {
                            return _c(
                              "div",
                              {
                                key: category.name,
                                staticClass: "automation-item category-item",
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.handleCategoryHover(
                                      $event,
                                      category.name
                                    )
                                  },
                                  mouseleave: _vm.handleCategoryLeave,
                                },
                              },
                              [
                                category.icon
                                  ? _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons category-icon-small",
                                      },
                                      [_vm._v(_vm._s(category.icon))]
                                    )
                                  : _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons category-icon-small",
                                      },
                                      [_vm._v("folder")]
                                    ),
                                _vm._v(" "),
                                _c("span", { staticClass: "automation-name" }, [
                                  _vm._v(_vm._s(category.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons submenu-arrow",
                                  },
                                  [_vm._v("chevron_right")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "submenu-dropdown",
                                    style:
                                      _vm.hoveredCategory === category.name
                                        ? _vm.submenuPosition
                                        : {},
                                    on: {
                                      mouseenter: _vm.cancelCategoryLeave,
                                      mouseleave: _vm.handleCategoryLeave,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "submenu-inner" },
                                      _vm._l(
                                        category.automations,
                                        function (automation) {
                                          return _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "tippy",
                                                  rawName: "v-tippy",
                                                },
                                              ],
                                              key: automation._id,
                                              staticClass: "automation-item",
                                              attrs: {
                                                content: automation.name,
                                                "data-tippy-placement":
                                                  "bottom",
                                                "data-tippy-theme":
                                                  "light-border",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.selectAutomation(
                                                    automation
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "automation-icon-wrapper",
                                                },
                                                [
                                                  _c("AutomationIcon", {
                                                    staticClass: "list-icon",
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "automation-name",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(automation.name)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.categoriesWithAutomations.length > 0 &&
                        _vm.generalAutomations.length > 0
                          ? _c("div", { staticClass: "divider" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.generalAutomations, function (automation) {
                          return _c(
                            "div",
                            {
                              directives: [
                                { name: "tippy", rawName: "v-tippy" },
                              ],
                              key: automation._id,
                              staticClass: "automation-item",
                              attrs: {
                                content: automation.name,
                                "data-tippy-placement": "bottom",
                                "data-tippy-theme": "light-border",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectAutomation(automation)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "automation-icon-wrapper" },
                                [
                                  _c("AutomationIcon", {
                                    staticClass: "list-icon",
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "automation-name" }, [
                                _vm._v(_vm._s(automation.name)),
                              ]),
                            ]
                          )
                        }),
                      ]
                    : _vm._l(
                        _vm.allCategoriesForInline,
                        function (category, index) {
                          return _c(
                            "div",
                            { key: category.name },
                            [
                              _c("div", { staticClass: "category-header" }, [
                                category.icon
                                  ? _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons category-icon-small",
                                      },
                                      [_vm._v(_vm._s(category.icon))]
                                    )
                                  : _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons category-icon-small",
                                      },
                                      [_vm._v("folder")]
                                    ),
                                _vm._v(" "),
                                _c("span", { staticClass: "category-title" }, [
                                  _vm._v(_vm._s(category.name)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                category.automations,
                                function (automation) {
                                  return _c(
                                    "div",
                                    {
                                      directives: [
                                        { name: "tippy", rawName: "v-tippy" },
                                      ],
                                      key: automation._id,
                                      staticClass: "automation-item",
                                      attrs: {
                                        content: automation.name,
                                        "data-tippy-placement": "bottom",
                                        "data-tippy-theme": "light-border",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectAutomation(
                                            automation
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "automation-icon-wrapper",
                                        },
                                        [
                                          _c("AutomationIcon", {
                                            staticClass: "list-icon",
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "automation-name" },
                                        [_vm._v(_vm._s(automation.name))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              index < _vm.allCategoriesForInline.length - 1
                                ? _c("div", { staticClass: "divider" })
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "automation-item create-new",
                  on: { click: _vm.showCreateAutomationModal },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "automation-name" }, [
                    _vm._v(_vm._s(_vm.$t("message.newAutomation"))),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: {
              click: function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createAutomationModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.createProfileAutomation"),
                "show-footer": false,
              },
              on: {
                close: function ($event) {
                  _vm.createAutomationModalVisible = false
                },
                cancel: function ($event) {
                  _vm.createAutomationModalVisible = false
                },
              },
            },
            [
              _c("a-alert", {
                staticClass: "mb-4",
                attrs: {
                  type: "info",
                  "show-icon": "",
                  message: _vm.$t("message.profileButtonClicked"),
                  description: _vm.$t("message.profileButtonDescription"),
                },
              }),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("message.automationName") },
                model: {
                  value: _vm.newAutomationName,
                  callback: function ($$v) {
                    _vm.newAutomationName = $$v
                  },
                  expression: "newAutomationName",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4 text-right" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function ($event) {
                          _vm.createAutomationModalVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createAutomation },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.create")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plus-icon-wrapper" }, [
      _c("span", { staticClass: "plus-icon" }, [_vm._v("+")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }